import { useMemo } from 'react';

import { useCreditCards } from './useCreditCards';

const useHasPrimaryCard = () => {
  const { data: creditCards, isLoading } = useCreditCards();

  return useMemo(() => {
    if (isLoading) {
      return false;
    }

    const hasPrimaryCard = creditCards?.length && creditCards.some((card) => card.primary);

    return !!hasPrimaryCard;
  }, [creditCards, isLoading]);
};

export default useHasPrimaryCard;
